// #region Component
// eslint-disable-next-line @typescript-eslint/naming-convention
export default function Loading(): JSX.Element {
    return (
        <div id="loading" className="k-loading-mask">
            <span className="k-loading-text">Loading..</span>
            <div className="k-loading-image"></div>
            <div className="k-loading-color"></div>
        </div>
    );
}
// #endregion